module.exports = __webpack_public_path__ + "img/generic1.9b80e4a7.jpg";